import {
  Box,
  Flex,
  Grid,
  HStack,
  Stack,
  useDisclosure,
} from '@chakra-ui/react';
import { RiAddLine } from 'react-icons/ri';
import { FiSearch, FiSend } from 'react-icons/fi';
import {
  ProposalDataFragment,
  useRequestsQuery,
} from '../../generated/graphql';
import { DashboardTrendingRequestCard } from '../Dashboard/DashboardTrendingRequestCard';
import { HelivanColor } from '../helivan/HelivanColor';
import { HelivanText } from '../helivan/HelivanText';
import { HelivanLoading } from '../HelivanLoading';
import { RequestModal } from './RequestModal';
import { FeatureRequestModal } from './FeatureRequestModal';
import { useState } from 'react';

export const Requests = () => {
  const { data, loading } = useRequestsQuery();
  // const activeTabBorderColor = 'blue.700';
  // const selectedTabBg = useColorModeValue('white', 'gray.800');
  const allRequests = data?.getAllRequests ?? [];
  const myRequests = allRequests?.filter((req) => req.createdByYou);
  const [viewType, setViewType] = useState<'browse' | 'mySubmissions'>(
    'browse'
  );
  const requestModal = useDisclosure();
  const featureRequestModal = useDisclosure();

  return loading ? (
    <HelivanLoading />
  ) : (
    <Stack
      height="full"
      width="full"
      gap={0}
      bg={HelivanColor.background.primary}
      border="1px solid"
      borderColor={HelivanColor.border.primary}
      borderRadius="8px"
      spacing={0}
      overflow="hidden"
    >
      <RequestModal
        isOpen={requestModal.isOpen}
        onClose={requestModal.onClose}
      />
      <FeatureRequestModal
        isOpen={featureRequestModal.isOpen}
        onClose={featureRequestModal.onClose}
      />
      <Flex
        width="full"
        alignItems="center"
        py="16px"
        px="30px"
        minHeight="45px"
        borderBottom="1px solid"
        borderBottomColor={HelivanColor.border.primary}
        position="sticky"
      >
        <HStack spacing={8}>
          <HelivanText variant="sectionHeader">Requests</HelivanText>
          <HStack spacing={4}>
            <Box
              onClick={() => {
                setViewType('browse');
              }}
              px="6px"
              py="2px"
              bg={viewType === 'browse' ? '#F6F8FF' : 'white'}
              border="0.5px solid #D0D0D0"
              borderRadius="4px"
              _hover={{ bg: '#F6F8FF' }}
              cursor="pointer"
            >
              <HStack spacing={2}>
                <FiSearch size={16} color="#486884" />
                <HelivanText variant="smallBody">Browse</HelivanText>
              </HStack>
            </Box>
            <Box
              onClick={() => {
                setViewType('mySubmissions');
              }}
              px="6px"
              py="2px"
              bg={viewType === 'mySubmissions' ? '#F6F8FF' : 'white'}
              border="0.5px solid #D0D0D0"
              borderRadius="4px"
              _hover={{ bg: '#F6F8FF' }}
              cursor="pointer"
            >
              <HStack spacing={2}>
                <FiSend size={16} color="#486884" />
                <HelivanText variant="smallBody">My Submissions</HelivanText>
              </HStack>
            </Box>
          </HStack>
        </HStack>
      </Flex>
      <Flex
        width="full"
        p="48px"
        borderBottomColor={HelivanColor.border.primary}
        bg="white"
        overflowY="scroll"
      >
        <RequestsGrid
          requests={viewType === 'browse' ? allRequests : myRequests}
          onCreate={requestModal.onOpen}
        />
      </Flex>
    </Stack>
  );
};

const RequestsGrid = ({
  requests,
  onCreate,
}: {
  requests: ProposalDataFragment[];
  onCreate?: () => void;
}) => {
  return (
    <Grid
      templateColumns={[
        'repeat(3, 1fr)',
        'repeat(3, 1fr)',
        'repeat(3, 1fr)',
        'repeat(3, 1fr)',
        'repeat(3, 1fr)',
        'repeat(4, 1fr)',
      ]}
      gap={6}
    >
      {onCreate && (
        <Flex
          width="full"
          height="280px"
          px="22px"
          py="18px"
          borderRadius="9px"
          borderWidth="0.75px"
          borderColor={HelivanColor.border.primary}
          bg="white"
          gap={6}
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          _hover={{
            cursor: 'pointer',
            boxShadow: '0px 0px 6px 2px rgba(0, 0, 0, 0.15)',
          }}
          onClick={onCreate}
          textAlign="center"
        >
          <RiAddLine size={50} color="black" />
          <HelivanText variant="sectionHeader" textAlign="center">
            Request
          </HelivanText>
          <HelivanText
            variant="largeBody"
            colorOverride="#114471"
            textAlign="center"
          >
            Don’t see anything you’re interested in? Request and you might see
            it created.
          </HelivanText>
        </Flex>
      )}
      {requests.map((request) => {
        return (
          <DashboardTrendingRequestCard
            key={request.id}
            id={request.id}
            title={request.title}
            type={request.type}
            upvotes={request.upvoteData.count}
            why={request.notes ?? ''}
            youUpvoted={request.upvoteData.upvotedByYou}
            dtType={request.dtType ?? undefined}
            size="lg"
            showDelete={!!onCreate}
          />
        );
      })}
    </Grid>
  );
};
